export default __webpack_public_path__ + "static/media/bg-site-internet.08be6f87.webp";